import i18n from './index';

/**
 * Translates a backend error message to the current language.
 * Maps known Spanish error strings from Cloud Functions to i18n keys.
 * Falls back to the raw server message if no mapping exists.
 */
export function translateError(serverMessage) {
  if (!serverMessage || typeof serverMessage !== 'string') return serverMessage;

  // Try direct mapping from the backend errors namespace
  const key = `errors:backend.${serverMessage}`;
  const translated = i18n.t(key, { defaultValue: '' });

  // If a translation was found (non-empty and different from the key), use it
  if (translated && translated !== key && translated !== '') {
    return translated;
  }

  // Fallback: return the raw server message
  return serverMessage;
}
